export class DtgDriverInfo {
    dtgDriverLcsNo:string;//dtg운전면허번호
    dtgEid:string;//dtg운송사업자 등록번호
    companyId:number;//회사코드
    dtgDriverNm:string;//loop 운전자명
    userDriverNm:string;    
    userDriverNmWithId:string;
    useYn:string;//사용여부
    createDt:string;
    createUser:string;
    updateDt:string;
    updateUser:string;
    userId:string;
    searchValue:string;
    driverGroupIdArrStr:string;
}
